import React, { useContext, useState } from "react"
import { storageData } from "services/Services"
import { ownedLeasedFinancedValidator } from "../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/validator";
import { RemoveVehicleContext } from "./RemoveVehicleContext";

export const DeleteVehicleContext = React.createContext()

const useModal = () => {
    const [modalTitle, setModalTitle] = useState("");
    const [modalMsg, setModalMsg] = useState("");
    const [showModal, setShowModal] = useState(false);

    const openModal = (title, message) => {
        setModalTitle(title);
        setModalMsg(message);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return {
        modalTitle,
        modalMsg,
        showModal,
        openModal,
        closeModal,
    };
};

export const DeleteVehicleContextComp = ({ children }) => {
    const removeVehicleContext = useContext(RemoveVehicleContext)
    // Fields for removing a vehicle
    const initialVehicle = {
        componentTracker: "",
        VIN: "",
        Year: "",
        Make: "",
        Model: "",
        Body: "",
        requestedRemovalEffDate: removeVehicleContext.getTodaysDate(true),
        garaged: "",
        vehicleRemovalReason: "",
        vehicleRemovalExplanation: ""
    }

    const [deleteVehicle, setDeletedVehicle] = useState(removeVehicleContext.removeVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles.length < 1 ?
        initialVehicle :
        { ...initialVehicle, ...removeVehicleContext?.removeVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles[0] }
    );
    const currResidenceBill = storageData.getItem("currResidenceBill")
    const policyStreetAddress = JSON.parse(currResidenceBill).address1
    const modal = useModal()
    const validateVehicles_3 = () => {
        return ownedLeasedFinancedValidator.validateForm(deleteVehicle, modal)
    }
    // Retrieves Form Values
    const removeVehCallback = (key, value) => {
        var vehicleCopy = deleteVehicle
        vehicleCopy[key] = value
        setDeletedVehicle({ ...deleteVehicle, ...vehicleCopy })
    }

    // Selected vehicle for deletion
    const removeSelectVehicle = (vehicle, index) => {
        var removeVehicleClassCopy = removeVehicleContext.removeVehicleClass
        removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles.length = 0
        removeVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles.push(vehicle)
        removeVehicleContext.setRemoveVehicleClass({ ...removeVehicleClassCopy })
        storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy))

        var vehicleCopy = vehicle
        setDeletedVehicle({ ...deleteVehicle, ...vehicleCopy })
    }

    return (
        <DeleteVehicleContext.Provider
            value={{
                deleteVehicle, setDeletedVehicle,
                initialVehicle,
                removeVehCallback,
                modal, policyStreetAddress,
                validateVehicles_3,
                removeSelectVehicle
            }}>
            {children}
        </DeleteVehicleContext.Provider>
    )
}